import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav3").addClass("active");
 var swiper = new Swiper(".mySwiper", {
      spaceBetween: 15,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        spaceBetween: 15,
        slidesPerView: 5,
      },
      768: {  //当屏幕宽度小于等于768
        spaceBetween: 15,
        slidesPerView: 4,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: 10,
        slidesPerView: 3,
      }
    } 
    });
    var swiper2 = new Swiper(".mySwiper2", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
});

if ( window.innerWidth> 1024) {
  $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
      var modulePosition = $('.product-details').offset().top; // 获取目标模块的顶部位置
      var moduleHeight = $('.product-details').outerHeight(); // 获取模块的高度（如果需要检测到达底部）
      var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
  // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
     if (scrollPosition >= modulePosition && scrollPosition < moduleHeight) {
         $(".swiper-box").addClass("fixed");
          $(".swiper-box").removeClass("fixed1");
          
    }else if (scrollPosition >= moduleHeight && scrollPosition < $("footer").offset().top) {
         $(".swiper-box").removeClass("fixed");
         $(".swiper-box").addClass("fixed1");
         
     }
    else {
         $(".swiper-box").removeClass("fixed");
         $(".swiper-box").removeClass("fixed1");

    }
    

     
  })
  
}
